import { useMemo } from 'react';
import { useLingui } from '@lingui/react/macro';

import { Permission } from '@/api';
import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTask from '@/icons/Task.svg';

import { PERMISSION_LABELS } from '../../permission-labels';
import { useFilters } from '../FiltersState';

const ALL_PERMISSIONS = Object.keys(PERMISSION_LABELS) as Permission[];

export const FiltersPermission = () => {
  const { t, i18n } = useLingui();

  const {
    permissions: { permissions, setPermissions },
  } = useFilters();

  const sortedPermissions = useMemo(
    () =>
      [...ALL_PERMISSIONS].sort((a, b) =>
        i18n._(PERMISSION_LABELS[a]).localeCompare(i18n._(PERMISSION_LABELS[b]))
      ),
    [i18n]
  );

  const togglePermission = (permission: Permission) => {
    if (permissions.includes(permission)) {
      setPermissions(permissions.filter((p) => p !== permission));
    } else {
      setPermissions([...permissions, permission]);
    }
  };

  const options = sortedPermissions.map((id) => (
    <FilterCheckboxItem key={id} id={id} label={i18n._(PERMISSION_LABELS[id])} />
  ));

  return (
    <FiltersSubMenu
      id="permission"
      icon={<IconTask />}
      label={t({
        id: 'settings.organization.roles.filters.permission.label',
        message: 'Permission',
      })}
      count={permissions.length}
    >
      <FiltersList
        ariaLabel={t({
          id: 'settings.organization.roles.filters.permission.label',
          message: 'Permission',
        })}
        values={permissions}
        onChange={togglePermission}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
